import ErrorPage from './default';
import { INCOMPATIBLE_PROMOTION_ERROR_PAGE_TEXT } from './constants';

function IncompatiblePromotionPage(props) {
  return (
    <ErrorPage
      {...props}
      title={INCOMPATIBLE_PROMOTION_ERROR_PAGE_TEXT.TITLE}
      description={INCOMPATIBLE_PROMOTION_ERROR_PAGE_TEXT.DESCRIPTION}
      buttonHref={INCOMPATIBLE_PROMOTION_ERROR_PAGE_TEXT.BUTTON_HREF}
      buttonText={INCOMPATIBLE_PROMOTION_ERROR_PAGE_TEXT.BUTTON_TEXT}
      iconColor="BLUE"
      iconId="informacion"
      showLink={false}
    />
  );
}
export default IncompatiblePromotionPage;
